export class RequestPricing {
    tipoCambio: number; 
    fechaPago: Date; 
    fechaPricing: Date;
}